import * as React from 'react';

import { Props } from './types';

const PlusIcon = ({ className }: Props) => (
  <svg
    data-testid="plus-icon"
    className={className}
    width="46"
    height="47"
    viewBox="0 0 46 47"
  >
    <path d="M23.4798 4.14087C24.5384 4.14087 25.3965 4.99899 25.3965 6.05754V20.9117H40.2507C41.3092 20.9117 42.1673 21.7698 42.1673 22.8284V23.7867C42.1673 24.8452 41.3092 25.7034 40.2507 25.7034H25.3965V40.5575C25.3965 41.6161 24.5384 42.4742 23.4798 42.4742H22.5215C21.4629 42.4742 20.6048 41.6161 20.6048 40.5575V25.7034H5.75065C4.69211 25.7034 3.83398 24.8452 3.83398 23.7867V22.8284C3.83398 21.7698 4.69211 20.9117 5.75065 20.9117H20.6048V6.05754C20.6048 4.99899 21.4629 4.14087 22.5215 4.14087H23.4798Z" />
  </svg>
);

export default React.memo(PlusIcon);
